<script lang="ts">
	import { serializeSchema, type Schema } from '$lib/utils/SchemaHelper';
	export let schema: Schema;
</script>

<svelte:head>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html serializeSchema(schema)}
</svelte:head>
